export const enum PlatformType {
  Web = 'web',
  Extension = 'ext',
  Mobile = 'mobile',
}
